import React, { useRef, useEffect, useState  } from "react";
import ReactToPrint from "react-to-print";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Card,
  Button,
  Paper,Grid
} from "@mui/material";
import { useAuth } from "../../../AuthProvider";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate,useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const baseUrl = process.env.REACT_APP_API_BASE_URL

const StudentPaymentsReceipts = () => {
  const componentRef = useRef();
  const { oId ,board,pId} = useAuth();
 const { admissionNumber,rolePayment } = useParams();
  const location = useLocation();
  // const { rowData,CategoryType } = location.state || {};

 const rowData = JSON.parse(sessionStorage.getItem("receiptRowData"));
  const category = sessionStorage.getItem("receiptCategoryType");

const formatDate = (dateStr) => {
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};


 const navigate = useNavigate();
  const [companyInfo, setCompanyInfo] = useState({
    schoolName: "",
    pincode: "",
    primaryContact: "",
    secondaryContact: "",
    boardAffiliation: "",
    schoolAddress: "",
    affiliationNumber: "",
    city: "",
    state: "",
    schoolEmailId: "",
    schoolLogo: "",
    schoolStamp: "",
  });
const [tempInfo, setTempInfo] = useState({ ...companyInfo });
const [orgloading, setOrgLoading] = useState(true); 
 const [transactionData, setTransactionData] = useState([]);
 const [studentData, setStudentData] = useState([]);
 const [totalAmount, setTotalAmount] = useState(0);
  const [payMethod, setPayMethodAmount] = useState('');
   const [tnxId, setTrnxId] = useState('');
  // const [loading, setLoading] = useState(true);

//organization details api 
    useEffect(() => {
      const fetchCompanyInfo = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          
  
          const data = await response.json();
          setCompanyInfo({
            schoolLogo: data.schoolLogo,
            schoolStamp:data.schoolStamp,
            schoolName: data.schoolName,
            city: data.city,
            state: data.state,
            affiliationNumber: data.affiliationNumber,
            schoolAddress: data.schoolAddress,
            primaryContact: data.primaryContact,
            boardAffiliation: data.boardAffiliation,
            secondaryContact: data.secondaryContact,
            pincode: data.pincode,
            schoolEmailId: data.schoolEmailId,
          });
          setTempInfo(data);
  
          setOrgLoading(false); // Data fetched, stop loading
  
        } catch (error) {
          console.error("Error fetching company info:", error);
          setOrgLoading(false); // Stop loading even if there's an error
        }
      };
  
      fetchCompanyInfo();
    }, []);




      useEffect(() => {
    const fetchStudentsData = async () => {
      if (!admissionNumber) return; // Prevent API call if no admission number is selected

    
      try {
        const response = await fetch(
          `${baseUrl}/api/admission/getAllStudentsDetailsAdmId/${admissionNumber}/${oId}/${pId}`
        );   
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setStudentData(data || []); // Ensure it's always an array
        

       
      } catch (error) {
        console.error("Error fetching Bus Numbers:", error);
        setStudentData([]); // Ensure state remains consistent
      } 
    };

    fetchStudentsData();
  }, [admissionNumber, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes



//   const handleDownload = async () => {
//   const input = componentRef.current;
//   if (!input) return;

//   try {
//     const canvas = await html2canvas(input);
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF("p", "mm", "a4");

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

//     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
//     pdf.save(`BusFeeReceipt_${studentData?.firstName || "Student"}.pdf`);
//   } catch (err) {
//     console.error("Error generating PDF", err);
//   }
// };

const handleDownload = async () => {
  const input = componentRef.current;
  if (!input) return;

  try {
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();

    const margin = 30; // 5mm margin on all sides
    const maxContentWidth = pageWidth - margin * 2;

    const contentHeight = (canvas.height * maxContentWidth) / canvas.width;

    const xOffset = margin; // 5mm from left
    const yOffset = margin; // 5mm from top

    pdf.addImage(imgData, "PNG", xOffset, yOffset, maxContentWidth, contentHeight);
    pdf.save(`${readableLabel}_FeeReceipt_${studentData?.firstName || "Student"}_${studentData?.lastName || ""}.pdf`);
  } catch (err) {
    console.error("Error generating PDF", err);
  }
};



  //     useEffect(() => {
  //   const fetchDialogTableData = async () => {
  //     if (!admissionNumber) return; // Prevent API call if no admission number is selected

    
  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/transaction/getAllTransaction/${admissionNumber}/${oId}/tution_fee`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch data");
  //       }

  //       const data = await response.json();
  //       console.log("Fetched Data:", data);
  //       setTransactionData(data || []); // Ensure it's always an array
  //       setTotalAmount(data.paymentAmount)
  //       setPayMethodAmount(data.payMethod)
  //       setTrnxId(data.transactionId)
  //     } catch (error) {
  //       console.error("Error fetching Bus Numbers:", error);
  //       setTransactionData([]); // Ensure state remains consistent
  //     } 
  //   };

  //   fetchDialogTableData();
  // }, [admissionNumber, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes




    function convertNumberToWords(num) {
    const words = [
      "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen",
      "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    if (num === 0) return words[0];
  
    function convertHundreds(n) {
      let result = "";
      if (n > 99) {
        result += words[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n > 19) {
        result += words[20 + Math.floor(n / 10) - 2] + (n % 10 !== 0 ? " " + words[n % 10] : "");
      } else if (n > 0) {
        result += words[n];
      }
      return result.trim();
    }
  
    function convertThousands(n) {
      if (n >= 1000) {
        return convertHundreds(Math.floor(n / 1000)) + " Thousand " + convertHundreds(n % 1000);
      } else {
        return convertHundreds(n);
      }
    }
  
    let integerPart = Math.floor(num); // Integer part of the number
    let decimalPart = Math.round((num - integerPart) * 100); // Fractional part (up to 2 decimal places)
  
    let result = "";
  
    // Process Crore
    if (integerPart >= 1e7) {
      result += convertThousands(Math.floor(integerPart / 1e7)) + " Crore ";
      integerPart %= 1e7;
    }
  
    // Process Lakh
    if (integerPart >= 1e5) {
      result += convertThousands(Math.floor(integerPart / 1e5)) + " Lakh ";
      integerPart %= 1e5;
    }
  
    // Process Thousand
    if (integerPart >= 1000) {
      result += convertThousands(Math.floor(integerPart / 1000)) + " Thousand ";
      integerPart %= 1000;
    }
  
    // Process Remaining Hundreds, Tens, and Ones
    if (integerPart > 0) {
      result += convertHundreds(integerPart);
    }
  
    // Handle decimal part if it exists
    if (decimalPart > 0) {
      result += " and " + convertHundreds(decimalPart) + " Paise";
    }
  
    return result.trim();
  }


  const roleLabels = {
  admission_fee: "Admission Fee",
  bus_fee: "Bus Fee",
  tution_fee: "Tuition Fee",
  other_fee: "Miscellaneous  Fee",
  exam_fee: "Exam Fee",
  hostel_fee: "Hostel Fee",
};

const readableLabel = roleLabels[rolePayment] || "Fee";



  return (
    <Card
      style={{
        padding: "20px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        marginTop: "5.3%",
        marginLeft: "15px",
        marginRight: "15px",
      }}
    >

     <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  {/* Left Section: Back Button and Title */}
  <Box display="flex" alignItems="center">
    <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
       {/* {`${CategoryType} Receipt`} */}
        {`${readableLabel} Receipt`}
    </Typography>
  </Box>

  {/* Right Section: Print Button */}
 <Box display="flex" justifyContent="flex-end" gap={2} mb={2}>
      {/* Download Button */}
      
        <Button
  variant="contained"
  onClick={handleDownload}
  sx={{
    backgroundColor: "#1976d2",
    color: "#fff",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "8px 18px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#1976d2",
    },
  }}
>
  Download
</Button>

      

      {/* Print Button */}
      <ReactToPrint
        trigger={() => (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontSize: "11px",
              fontWeight: "bold",
              padding: "8px 18px",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#1976d2",
              },
            }}
          >
            Print
          </Button>
        )}
        content={() => componentRef.current}
      />
    </Box>
</Box>


      <Box
        sx={{
          width: "600px",
          margin: "auto",
          padding: 2,
          backgroundColor: "#fff",
          border: "1px solid black",
          fontFamily: "serif",
          marginTop:"30px"
        }}
        ref={componentRef}
        p={4}
        component={Paper}
        elevation={0}
      
      >
      <Box display="flex" alignItems="center" mb={2}>
  {/* Left: Logo */}
  <Box mr={2}>
    <img
      src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
      alt="School Logo"
      style={{ width: 80, height: 80 }}
    />
  </Box>

  {/* Center: School Details */}
  <Box flex={1} textAlign="center">
    <Typography fontWeight="bold" fontSize="18px">
      {companyInfo.schoolName}
    </Typography>
    <Typography fontSize="14px">
      {companyInfo.schoolEmailId}
    </Typography>
    <Typography fontSize="14px">
      {companyInfo.primaryContact}
    </Typography>
    <Typography fontSize="14px">
      {companyInfo.schoolAddress}
    </Typography>
    <Typography fontWeight="bold" fontSize="16px" mt={1}>
       Receipt
    </Typography>
  </Box>

  {/* Right: (optional, leave empty or add content if needed) */}
  <Box width={80} /> {/* Placeholder space to balance the layout */}
</Box>



<Box mt={2}>
  <Grid container spacing={2} justifyContent="space-between">
    {/* Left Section: Student Info */}
    <Grid item xs={12} sm={6}>
      <Box>
        <Grid container>
          <Grid item xs={4}>
            <Typography fontWeight="bold">Name:</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography>
              {studentData.firstName} {studentData.lastName}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography fontWeight="bold">
              {board === "INTERMEDIATE" ? "Year:" : "Class:"}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography>{studentData.romanNumberClass}</Typography>
          </Grid>

          {board === "INTERMEDIATE" && (
            <>
              <Grid item xs={4}>
                <Typography fontWeight="bold">Course:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography>{studentData.course}</Typography>
              </Grid>
            </>
          )}

          <Grid item xs={4}>
            <Typography fontWeight="bold">Section:</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography>{studentData.sections}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Grid>

    {/* Right Section: Receipt Info */}
    <Grid item xs={12} sm={5}>
      <Box>
        <Grid container>
          <Grid item xs={6}>
            <Typography fontWeight="bold" textAlign="right">
              Receipt No:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography textAlign="right">
              {rowData?.receiptNo || "_____"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography fontWeight="bold" textAlign="right">
              Date of Payment:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography textAlign="right"> {formatDate(rowData?.paymentDate)}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  </Grid>
</Box>




        <Table size="small" sx={{ mt: 2, border: "1px solid black" }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: "1px solid black", width: "12%" ,fontWeight:'bold'}}>Sl No.</TableCell>
              <TableCell sx={{ border: "1px solid black" ,fontWeight:'bold'}}>Particulars</TableCell>
              <TableCell sx={{ border: "1px solid black", width: "20%",fontWeight:'bold' }}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           
              <TableRow >
                <TableCell sx={{ border: "1px solid black" }}>1</TableCell>
                <TableCell sx={{ border: "1px solid black" }}>{readableLabel}</TableCell>
                <TableCell sx={{ border: "1px solid black" }}>{rowData?.paymentAmount}</TableCell>
              </TableRow>
         
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{ border: "1px solid black", textAlign: "right", fontWeight: "bold" }}
              >
                Total
              </TableCell>
              <TableCell sx={{ border: "1px solid black", fontWeight: "bold" }}>₹ {rowData?.paymentAmount}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Typography>
            Paid By: <strong>{rowData?.payMethod}</strong>
          </Typography>
          <Typography>
            Amount (In words): <strong>{convertNumberToWords(rowData?.paymentAmount)}</strong>
          </Typography>
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={3}>
        
          <Box mr={2}>
    <img
      src={`data:image/jpeg;base64,${companyInfo.schoolStamp}`}
      alt="School Logo"
      style={{ width: 65, height: 65 }}
    />
  </Box>
        </Box>

        {/* <Divider sx={{ my: 2 }} />

        <Typography fontSize="12px" textAlign="center">
          All above mentioned Amount once paid are non-refundable in any case whatsoever.
        </Typography> */}
      </Box>
    </Card>
  );
};

export default StudentPaymentsReceipts;